import api from '../api';

export function recoverPassword(email: string): Promise<void> {
  return api.post('recover-password', { email }).then(() => undefined);
}

export function resetPassword(tokenValue: string, password: string): Promise<void> {
  return api.post('reset-password', { tokenValue, password }).then(() => undefined);
}

export function changePassword(
  userId: string, currentPassword: string, newPassword: string,
): Promise<void> {
  return api
    .post(`/users/${userId}/password`, {
      currentPassword,
      newPassword,
    }).then();
}
